<ng-container *ngIf="inviteExceed()">
  <div class="error-box">
    <div class="icon-container">
      <img
        style="width: 24px"
        src="assets/svg/ico-alert-red.svg"
        alt="warning icon"
      />
    </div>
    <div class="text-container">
      <span class="error-text bold">
        {{ "INVITATION_LIMIT_EXEEDED" | translate }}
      </span>
      <span class="error-text">
        {{ "CONTACT_SALES_FOR_MORE_INVITE" | translate }}
      </span>
    </div>
  </div>
</ng-container>
